import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

// Components
import CalendarInput from "../../components/CalendarInput/CalendarInput";
import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import ToClose from "../../components/ToClose/ToClose";

// Icons
import { RiFileTextLine } from "react-icons/ri";

// Styles
import styles from "./AddObservation.module.css";

const AddObservation = () => {
  const dispatch = useDispatch();

  const [date, setDate] = useState("");
  const [title, setTitle] = useState("");
  const [notes, setNotes] = useState("");

  const handleSave = () => {
    console.log({
      date,
      title,
      notes,
    });
  
  };

  const handleCancel = () => {
    setDate("");
    setTitle("");
    setNotes("");

  };

  return (
    <div className={styles.cardContainer}>
      <div className={styles.header}>
        <HeadingAndIcon icon={<RiFileTextLine />} heading="Add observation" />
        <ToClose onClose={() => dispatch(closeModal())} />
      </div>

      <div className={styles.body}>
        <div>
          <CalendarInput
            fieldLabel="Observation date"
            value={date}
            onChange={setDate}
            required
          />
        </div>
        <div>
          <HeadingAndData
            label="Title"
            name="title"
            placeholder="Select development areas"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>

        <div className={styles.inputBlock}>
          <label htmlFor="notes" className={styles.inputLabel}>
            Notes<span className={styles.required}> *</span>
          </label>
          <textarea
            id="notes"
            name="notes"
            placeholder="Choose lesson categories"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            className={styles.textarea}
            required
          />
        </div>

        <div className={styles.actions}>
          <SaveAndCancel onSave={handleSave} onCancel={handleCancel} />
        </div>
      </div>
    </div>
  );
};

export default AddObservation;
